const DEFAULT_API_BASE_URL = "/";

// -------------------------------------------------------------------------------------------------------
// 1. API URL BUILDER

export const getApiBaseUrl = () => {
  return process.env.REACT_APP_BASE_API || DEFAULT_API_BASE_URL;
};

export const getApiUrl = (path) => {
  const baseUrl = getApiBaseUrl();
  const cleanBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;

  return `${cleanBaseUrl}${cleanPath}`;
};
